var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container"},[_c('van-error',{attrs:{"figure":2,"title":"您访问的页面不存在！","tip":"您可能输错地址，或页面已删除！","button":"返回首页"},on:{"clickButton":_vm.close}}),_c('div',{staticClass:"copyright"},[_vm._v(_vm._s(_vm.copyRight))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }